import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_USU_PERFILES = 'ALL_USU_PERFILES';
export const LOADING_ALL_USU_PERFILES = 'LOADING_ALL_USU_PERFILES';
export const ACTIVO_USU_PERFILES = 'ACTIVO_USU_PERFILES';
export const PARAMS_USU_PERFILES = 'PARAMS_USU_PERFILES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const usuEntPerfilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_USU_PERFILES:
      return {
        ...state,
        all: action.payload.data,
      };
    case LOADING_ALL_USU_PERFILES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_USU_PERFILES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_USU_PERFILES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
